// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__EfiCv","icons":"footer_icons__tBVWP","iconsCreators":"footer_iconsCreators__6EU1N"};